import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Calendar, LoaderOverlay } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useDocumentNoticeDate } from 'app/domains/metadata';
import { ChipDropdown } from 'shared/domains/common-ui';
import { useActiveDocument } from 'shared/domains/documents';
import { localeConfig } from 'shared/domains/languages/config';
export function NoticeDateChip() {
    const { id } = useActiveDocument();
    const [open, setOpen] = useState(false);
    const closeMenu = () => setOpen(false);
    const localeCode = localeConfig.getActiveLocale().code;
    const action = useDocumentNoticeDate({
        documentId: id,
        onCompleted: closeMenu,
    });
    if (!action.data.warning) {
        return null;
    }
    return (<ChipDropdown open={open} appearance="warning" icon={<Falcon icon="circle-exclamation"/>} label={t({
            comment: 'Actionable insights: Document notice date chip label',
            message: 'Notice date',
        })} secondary={action.data.localizedDate} size="medium" onClose={closeMenu}>
      <LoaderOverlay transparent enabled={action.savingData}>
        <Calendar value={action.data.value} locale={localeCode} onChange={action.update}/>
      </LoaderOverlay>
    </ChipDropdown>);
}
